import React from "react";
import { Form, Button, Col, Row, Select, DatePicker } from "antd";

const { RangePicker } = DatePicker;
import { SystemMessageUserGroupText, SystemMessageTypeText, SystemMessageStatusText } from "../../../models/enums";
import styles from "./systemMessagesFilterForm.scss";

const SystemMessagesFilterForm = ({ onSubmit, onNewMessage, form }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    const values = form.getFieldsValue();
    const params = {};
    if (values.userGroup !== undefined && values.userGroup !== null) params.userGroup = values.userGroup;
    if (values.type !== undefined && values.type !== null) params.type = values.type;
    if (values.status !== undefined && values.status !== null) params.status = values.status;
    if (values.dateRange && values.dateRange.length === 2) {
      params.dateFrom = values.dateRange[0].format("YYYY-MM-DD");
      params.dateTo = values.dateRange[1].format("YYYY-MM-DD");
    }
    onSubmit(params);
  };

  const handleReset = () => {
    form.resetFields();
    onSubmit({});
  };

  return (
    <Row gutter={2} className={styles.form}>
      <Form layout="horizontal" onSubmit={handleSubmit}>
        <Col md={12} sm={24} lg={4} xl={4}>
          <Form.Item className={styles.gutterBox}>
            {form.getFieldDecorator("userGroup")(
              <Select placeholder="Ciljna grupa" allowClear>
                {SystemMessageUserGroupText.map((opt) => (
                  <Select.Option key={opt.value} value={opt.value}>
                    {opt.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col md={12} sm={24} lg={3} xl={3}>
          <Form.Item className={styles.gutterBox}>
            {form.getFieldDecorator("type")(
              <Select placeholder="Tip poruke" allowClear>
                {SystemMessageTypeText.map((opt) => (
                  <Select.Option key={opt.value} value={opt.value}>
                    {opt.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col md={12} sm={24} lg={3} xl={3}>
          <Form.Item className={styles.gutterBox}>
            {form.getFieldDecorator("status")(
              <Select placeholder="Status" allowClear>
                {SystemMessageStatusText.map((opt) => (
                  <Select.Option key={opt.value} value={opt.value}>
                    {opt.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col md={12} sm={24} lg={5} xl={5}>
          <Form.Item className={styles.gutterBox}>
            {form.getFieldDecorator("dateRange")(
              <RangePicker
                format="DD.MM.YYYY"
                placeholder={["Datum od", "Datum do"]}
                className={styles.fullWidth}
              />
            )}
          </Form.Item>
        </Col>
        <Col md={8} sm={24} lg={3} xl={3}>
          <Form.Item className={styles.gutterBox}>
            <Button type="primary" htmlType="submit" className={styles.actionButton}>
              Pretraži
            </Button>
          </Form.Item>
        </Col>
        <Col md={8} sm={24} lg={3} xl={3}>
          <Form.Item className={styles.gutterBox}>
            <Button onClick={handleReset} className={styles.actionButton}>
              Resetiraj
            </Button>
          </Form.Item>
        </Col>
        <Col md={8} sm={24} lg={3} xl={3}>
          <Form.Item className={styles.gutterBox}>
            <Button type="primary" onClick={onNewMessage} className={styles.actionButton}>
              Nova poruka
            </Button>
          </Form.Item>
        </Col>
      </Form>
    </Row>
  );
};

export default Form.create()(SystemMessagesFilterForm);



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageSystemMessagesPage/SystemMessagesFilterForm.tsx